"use-strict";

export class MobileDetect {
    constructor () {
        MobileDetect.navigator = window.navigator;
        MobileDetect.body = document.body;

        if (MobileDetect.any()) {
            MobileDetect.body.classList.add('mobile');
            if (MobileDetect.android()) {
                MobileDetect.body.classList.add('android');
            }
            if (MobileDetect.iOS()) {
                MobileDetect.body.classList.add('ios');
            }
            if (MobileDetect.opera()) {
                MobileDetect.body.classList.add('opera');
            }
            if (MobileDetect.windows()) {
                MobileDetect.body.classList.add('windows');
            }
        } else {
            MobileDetect.body.classList.add('desktop');
        }

        /*if (mobileDetect.safari()) {
            body.classList.add('safari');
        }*/
    }

    static android () {
        return MobileDetect.navigator.userAgent.match(/Android/i);
    }

    static blackBerry () {
        return MobileDetect.navigator.userAgent.match(/BlackBerry/i);
    }

    static iOS () {
        return MobileDetect.navigator.userAgent.match(/iPhone|iPad|iPod/i);
    }

    static safari () {
        return MobileDetect.navigator.userAgent.match(/Safari/i);
    }

    static opera () {
        return MobileDetect.navigator.userAgent.match(/Opera Mini/i);
    }

    static windows () {
        return MobileDetect.navigator.userAgent.match(/IEMobile/i);
    }
    static any() {
        return (
            MobileDetect.android()
            || MobileDetect.blackBerry()
            || MobileDetect.iOS()
            /*|| MobileDetect.safari()*/
            || MobileDetect.opera()
            || MobileDetect.windows()
            || MobileDetect.blackBerry()
        );
    }
}
